import { websites } from '@/mocks/navigation';

export default function FeaturedWebsites() {
  const featured = websites.slice(0, 12);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            推荐正品网站
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选优质正品网站，安全可靠，值得信赖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
          {featured.map((site) => (
            <a
              key={site.id}
              href={site.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-background-50 border border-background-200/70 hover:border-primary-300 rounded-xl p-4 md:p-5 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-500 transition-colors">
                  <span className="text-sm font-bold text-primary-600 group-hover:text-background-50 transition-colors">
                    {site.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                    {site.name}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {site.description}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-1.5 mt-3 pt-3 border-t border-background-100">
                {site.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-md"
                  >
                    {tag}
                  </span>
                ))}
                <div className="ml-auto flex items-center gap-1 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>访问</span>
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}